import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../store/hooks";
import { logoutAsync } from "../slices/auth/authSlice";

const useAutoLogout = (timeout = 60 * 60 * 1000) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const events = ["mousemove", "keydown", "mousedown", "touchstart"];
        let timer = setTimeout(logout, timeout);

        function resetTimer() {
            clearTimeout(timer);
            timer = setTimeout(logout, timeout);
        }

        function logout() {
            dispatch(logoutAsync()).then(() => {
                navigate("/sign-in");
                localStorage.clear();
            });
        }

        events.forEach((event) => window.addEventListener(event, resetTimer));

        return () => {
            clearTimeout(timer);
            events.forEach((event) => window.removeEventListener(event, resetTimer));
        };
    }, [dispatch, navigate, timeout]);
};

export default useAutoLogout;
